// Single source of truth for member testimonial screenshots.
// Used by both the Testimonials wall and the Home page bottom carousel.
const CDN = "https://customer-assets-jai6qajn.emergentagent.net/job_community-redesign-1/artifacts";

export const TESTIMONIALS = [
  // NEWEST BATCH (Aug 31, 2026 · pm)
  `${CDN}/jlutioad_IMG_5996.JPG`,    // fone Jupiter Position PnL — +$148.57 · +108.3%
  `${CDN}/vpvkfv9g_IMG_5997.webp`,   // Wins channel — apeonfone summary +$16.20 · 5,525% + fone card
  // Previous batch (Aug 31, 2026)
  `${CDN}/3kalsyg9_IMG_5991.JPG`,    // fone Nomi chart — +$0.00439 · +3,211.3%
  `${CDN}/spluf65g_IMG_5988.webp`,   // JB chat "cmon" + Position PnL +$441.43 · +33.87%
  `${CDN}/rjppakef_IMG_5986.JPG`,    // fone GMGN card — +$10.82K
  `${CDN}/yltrii1q_IMG_5985.JPG`,    // fone GMGN card — +$4.82K
  `${CDN}/u3256bp4_IMG_5983.jpg`,    // fone Jupiter — +$450.09 · +29.57%
  // Previous batch (Aug 30, 2026 · pm)
  `${CDN}/gf7cz3w3_IMG_5965.webp`,   // Martians — +$2,281.63 · +116.82% Jupiter card
  `${CDN}/mh27if6i_IMG_5966.webp`,   // Wins chat — two Martians cards ($2,281.63 & $54.41)
  `${CDN}/6287mza3_IMG_5968.webp`,   // Wins chat — $4,061 Martians + jcrzz +$33 fomo card
  `${CDN}/sk19hlg5_IMG_5982.webp`,   // fone — $55.27 + $77.98 wins channel
  // Previous batch (Aug 30, 2026 · am)
  `${CDN}/d3umbumf_IMG_5875.jpg`,    // Dinger — +$310.45 · +62.73% Jupiter card
  `${CDN}/4d6fx2wt_IMG_5648.webp`,   // BLACKGUY — Jupiter +$164 · +221.05% (Crypto Chat)
  "/brand/testimonial_pca_blurred.png", // PCA — +$38.50 · "quick 45% this morning" (phone number blurred)
  `${CDN}/ej9zvdi4_IMG_5608.webp`,   // Regulardude — +$34.99 · +233% + +$74.9 · +500% (Crypto Chat)
  `${CDN}/4j432y4u_IMG_5598.webp`,   // claudius — +$291.46 & +$509.60 wins channel
  // Previous batch (Aug 29, 2026)
  `${CDN}/k30mildw_IMG_5594.webp`,   // Dan will Spooner — "Made 500 on mate left the rest to ride"
  `${CDN}/x8iqrn3d_IMG_5568.jpg`,    // Chiikawa Jupiter +$958.30 · +22.19%
  `${CDN}/a3tdbxqs_IMG_5566.webp`,   // Maximilian — "17 year old i took the Risk"
  `${CDN}/k251v6uw_IMG_5559.webp`,   // claudius Jupiter +$211 · +143.41% (astronaut cat)
  `${CDN}/2j92slr2_IMG_5515.webp`,   // Arvid — "Bro i made 700 in less than 15 min"
  // Previous newest batch (late Aug 2026)
  `${CDN}/yyvn6lac_IMG_5500.webp`,   // Jmb — "In profit... Gonna print thousands bro"
  `${CDN}/1lojn1il_IMG_5483.webp`,   // Position PnL — CATE +$89.27 · +20.79% + Trade History
  `${CDN}/pgylb030_IMG_5478.webp`,   // CATE Ai66 — Total PnL +$1,010.84 · +54.09%
  `${CDN}/tt5arenj_IMG_5387.jpg`,    // fone — $75.23 wins + $3.51 axiom card
  `${CDN}/ppfkb2le_F6C68608-E483-4F54-816B-66EA6F67F92B.webp`, // seconddraft — "i bought cate cause of you at 400 euro"
  // Previous newest batch (Aug 27, 2026)
  `${CDN}/k8uia1o2_97bc0cc3-fbc8-415a-8359-2e1bc1f9f0d6.JPG`,   // CATE +$27.8k · +325.26%
  `${CDN}/iwlwb425_9C94AABA-6A8D-4C6B-BE97-D3AE06902C67.webp`,  // Ashley Wood — CATE +$19.1k · Net Worth $23,377
  `${CDN}/cwpjo3nt_7030244C-E685-4254-B4D5-CF0170A62126.webp`,  // Ashley Wood — CATE +$7.57k
  `${CDN}/gsjbukme_67511c6d30c5c91a81e178da8dc13291.JPG`,       // fone (CTPo…pump) $55 & $77 wins
  `${CDN}/7uf0prcc_6a9b5c042908119643867a8aa97811cb.webp`,      // Martians (7nLu…pump) $2,281 & $54 wins
  // Previous newest batch (Aug 2026)
  `${CDN}/9yc8vcr3_IMG_5475.webp`,   // "The CEO" — $21k BTC 2.88% move
  `${CDN}/3wtk2lcv_IMG_5437.webp`,   // cbcapital_fx — up £50k for the month
  // PREVIOUS BATCH (late Jul 2026)
  `${CDN}/vyfejbot_IMG_5440.webp`,   // XAUUSD/BTCUSD +£36,875 history
  `${CDN}/6zpelknm_IMG_5474.webp`,   // Nik — $19,502 doubled in 13 days
  `${CDN}/isyqe2xg_IMG_5439.jpeg`,   // Mercedes AMG paid for in crypto
  `${CDN}/5nlpm627_IMG_5471.webp`,   // Layoff wallets $1,119 & $2,070
  `${CDN}/h1xv3xlg_IMG_5438.webp`,   // Raza Syndicate 141.49 GBP from £30
  // Jul 2026 batch
  `${CDN}/630lzud0_IMG_5338.JPG`,
  `${CDN}/mjajowcr_IMG_5339.JPG`,
  `${CDN}/ibjquyu2_2a9a3c23facec1e7ac4c07b051779597.webp`,
  `${CDN}/wq4k1ei0_IMG_5379.webp`,
  `${CDN}/k2937ll1_IMG_5337.JPG`,
  // PnL / Trade receipts
  `${CDN}/ozeofxw8_IMG_4199.webp`,
  `${CDN}/tkze1ek8_IMG_3984.webp`,
  `${CDN}/fhxudusj_IMG_3390.JPG`,
  `${CDN}/rw5pj56y_IMG_3515.JPG`,
  `${CDN}/29vwsju1_IMG_3520.JPG`,
  `${CDN}/g4k5vnh3_IMG_4011.webp`,
  `${CDN}/ms2v8kx5_IMG_4012.webp`,
  `${CDN}/ymqwtgp2_IMG_4200.webp`,
  // Chat testimonials + real member DMs
  `${CDN}/j6spy11y_IMG_48608E7ACDB4-1.jpeg`,
  `${CDN}/2iuoza9c_photo_2026-07-22%2022.05.30.jpeg`,
  `${CDN}/tjw8g8zv_photo_2026-07-22%2022.05.21.jpeg`,
];
